import classNames from "classnames";
import { makeStyles } from '@material-ui/core/styles';
import { RoundEntry } from "../stores/RoundStore";

enum VoteStage {
  PENDING,
  IN_PROGRESS,
  COMPLETE,
}

interface VoteRoundStatusProps {
  stage: VoteStage;
}

const useStyles = makeStyles(() => ({
  grey: {
    color: 'grey',
  },
}));

function VoteRoundStatus(props: VoteRoundStatusProps) {
  const classes = useStyles();
  switch (props.stage) {
    case VoteStage.PENDING:
      return (
        <div className={classNames('progress-box', 'pending-status', classes.grey)}>
          <span className="check-icon">Pending</span>
        </div>
      );
    case VoteStage.IN_PROGRESS:
      return (
        <div className="progress-box inprogress-status">
          <span className="check-icon">IN PROGRESS</span>
        </div>
      );
    case VoteStage.COMPLETE:
      return (
        <div className="progress-box complete-status">
          <span className="check-icon">Complete</span>
        </div>
      );
  }
}

interface SimpleRoundEntry {
  name: string;
}

interface VoteRoundHeadingProps {
  selectRound(e: any, round: RoundEntry): void;

  index: number;
  round: RoundEntry;
  activeRound: SimpleRoundEntry | null;
  allVotesPresent: boolean;
}

export function VoteRoundHeading(props: VoteRoundHeadingProps) {
  const classes = useStyles();
  const outerBox =
    "wizard-outer-box voteRoundBox " +
    (props.round.name === props.activeRound?.name ? " active" : "");
  const stepBox = `step-box step-${props.index}`;
  const endTime = Date.parse(props.round.end_time);
  const currentTime = Date.now();

  // choose the vote stage
  let stage: VoteStage;
  if (currentTime >= endTime) {
    stage = VoteStage.COMPLETE;
  }
  else {
    if (props.round.active) {
      if (props.allVotesPresent) {
        stage = VoteStage.COMPLETE;
      } else {
        stage = VoteStage.IN_PROGRESS;
      }
    }
    else {
      stage = VoteStage.PENDING;
    }
  }

  return (
    <div className="col-12 col-md-4">
      <a
        href="/vote"
        className="voteRoundA"
        onClick={(e) => props.selectRound(e, props.round)}
      >
        <div className={outerBox}>
          <div className={stepBox}>
            <h4 className={classNames({[classes.grey]: stage === VoteStage.PENDING})}>PHASE {props.index + 1}</h4>
            <h3 className={classNames({[classes.grey]: stage === VoteStage.PENDING})}>
              {props.round.title ?? props.round.name}
            </h3>
            <VoteRoundStatus stage={stage} />
          </div>
        </div>
      </a>
    </div>
  );
}
